<script setup>

import {computed, onMounted, reactive, ref, watch} from "vue";

const emit = defineEmits(['nextStage', 'parametersUpdated'])

const searchFields = ref([
    {
        label: _mft('leadHunterCampaign:audience.fields.jobTitle.label'),
        field: 'job_title',
        type: 'multiText',
        inputPlaceholder: 'CEO, HR, Marketing etc.'
    },
    {
        label: _mft('leadHunterCampaign:audience.fields.companyIndustry.label'),
        field: 'company_industry',
        type: 'options',
        options: [
            {
                label: 'Accounting',
                value: 'accounting',
            },
            {
                label: 'Airlines/aviation',
                value: 'airlines/aviation',
            },
            {
                label: 'Alternative dispute resolution',
                value: 'alternative dispute resolution',
            },
            {
                label: 'Alternative medicine',
                value: 'alternative medicine',
            },
            {
                label: 'Animation',
                value: 'animation',
            },
            {
                label: 'Apparel & fashion',
                value: 'apparel & fashion',
            },
            {
                label: 'Architecture & planning',
                value: 'architecture & planning',
            },
            {
                label: 'Arts and crafts',
                value: 'arts and crafts',
            },
            {
                label: 'Automotive',
                value: 'automotive',
            },
            {
                label: 'Aviation & aerospace',
                value: 'aviation & aerospace',
            },
            {
                label: 'Banking',
                value: 'banking',
            },
            {
                label: 'Biotechnology',
                value: 'biotechnology',
            },
            {
                label: 'Broadcast media',
                value: 'broadcast media',
            },
            {
                label: 'Building materials',
                value: 'building materials',
            },
            {
                label: 'Business supplies and equipment',
                value: 'business supplies and equipment',
            },
            {
                label: 'Capital markets',
                value: 'capital markets',
            },
            {
                label: 'Chemicals',
                value: 'chemicals',
            },
            {
                label: 'Civic & social organization',
                value: 'civic & social organization',
            },
            {
                label: 'Civil engineering',
                value: 'civil engineering',
            },
            {
                label: 'Commercial real estate',
                value: 'commercial real estate',
            },
            {
                label: 'Computer & network security',
                value: 'computer & network security',
            },
            {
                label: 'Computer games',
                value: 'computer games',
            },
            {
                label: 'Computer hardware',
                value: 'computer hardware',
            },
            {
                label: 'Computer networking',
                value: 'computer networking',
            },
            {
                label: 'Computer software',
                value: 'computer software',
            },
            {
                label: 'Construction',
                value: 'construction',
            },
            {
                label: 'Consumer electronics',
                value: 'consumer electronics',
            },
            {
                label: 'Consumer goods',
                value: 'consumer goods',
            },
            {
                label: 'Consumer services',
                value: 'consumer services',
            },
            {
                label: 'Cosmetics',
                value: 'cosmetics',
            },
            {
                label: 'Dairy',
                value: 'dairy',
            },
            {
                label: 'Defense & space',
                value: 'defense & space',
            },
            {
                label: 'Design',
                value: 'design',
            },
            {
                label: 'E-learning',
                value: 'e-learning',
            },
            {
                label: 'Education management',
                value: 'education management',
            },
            {
                label: 'Electrical/electronic manufacturing',
                value: 'electrical/electronic manufacturing',
            },
            {
                label: 'Entertainment',
                value: 'entertainment',
            },
            {
                label: 'Environmental services',
                value: 'environmental services',
            },
            {
                label: 'Events services',
                value: 'events services',
            },
            {
                label: 'Executive office',
                value: 'executive office',
            },
            {
                label: 'Facilities services',
                value: 'facilities services',
            },
            {
                label: 'Farming',
                value: 'farming',
            },
            {
                label: 'Financial services',
                value: 'financial services',
            },
            {
                label: 'Fine art',
                value: 'fine art',
            },
            {
                label: 'Fishery',
                value: 'fishery',
            },
            {
                label: 'Food & beverages',
                value: 'food & beverages',
            },
            {
                label: 'Food production',
                value: 'food production',
            },
            {
                label: 'Fund-raising',
                value: 'fund-raising',
            },
            {
                label: 'Furniture',
                value: 'furniture',
            },
            {
                label: 'Gambling & casinos',
                value: 'gambling & casinos',
            },
            {
                label: 'Government administration',
                value: 'government administration',
            },
            {
                label: 'Government relations',
                value: 'government relations',
            },
            {
                label: 'Graphic design',
                value: 'graphic design',
            },
            {
                label: 'Health, wellness and fitness',
                value: 'health, wellness and fitness',
            },
            {
                label: 'Higher education',
                value: 'higher education',
            },
            {
                label: 'Hospital & health care',
                value: 'hospital & health care',
            },
            {
                label: 'Hospitality',
                value: 'hospitality',
            },
            {
                label: 'Human resources',
                value: 'human resources',
            },
            {
                label: 'Import and export',
                value: 'import and export',
            },
            {
                label: 'Individual & family services',
                value: 'individual & family services',
            },
            {
                label: 'Industrial automation',
                value: 'industrial automation',
            },
            {
                label: 'Information services',
                value: 'information services',
            },
            {
                label: 'Information technology and services',
                value: 'information technology and services',
            },
            {
                label: 'Insurance',
                value: 'insurance',
            },
            {
                label: 'International affairs',
                value: 'international affairs',
            },
            {
                label: 'International trade and development',
                value: 'international trade and development',
            },
            {
                label: 'Internet',
                value: 'internet',
            },
            {
                label: 'Investment banking',
                value: 'investment banking',
            },
            {
                label: 'Investment management',
                value: 'investment management',
            },
            {
                label: 'Judiciary',
                value: 'judiciary',
            },
            {
                label: 'Law enforcement',
                value: 'law enforcement',
            },
            {
                label: 'Law practice',
                value: 'law practice',
            },
            {
                label: 'Legal services',
                value: 'legal services',
            },
            {
                label: 'Legislative office',
                value: 'legislative office',
            },
            {
                label: 'Libraries',
                value: 'libraries',
            },
            {
                label: 'Logistics and supply chain',
                value: 'logistics and supply chain',
            },
            {
                label: 'Luxury goods & jewelry',
                value: 'luxury goods & jewelry',
            },
            {
                label: 'Machinery',
                value: 'machinery',
            },
            {
                label: 'Management consulting',
                value: 'management consulting',
            },
            {
                label: 'Maritime',
                value: 'maritime',
            },
            {
                label: 'Market research',
                value: 'market research',
            },
            {
                label: 'Marketing and advertising',
                value: 'marketing and advertising',
            },
            {
                label: 'Mechanical or industrial engineering',
                value: 'mechanical or industrial engineering',
            },
            {
                label: 'Media production',
                value: 'media production',
            },
            {
                label: 'Medical devices',
                value: 'medical devices',
            },
            {
                label: 'Medical practice',
                value: 'medical practice',
            },
            {
                label: 'Mental health care',
                value: 'mental health care',
            },
            {
                label: 'Military',
                value: 'military',
            },
            {
                label: 'Mining & metals',
                value: 'mining & metals',
            },
            {
                label: 'Motion pictures and film',
                value: 'motion pictures and film',
            },
            {
                label: 'Museums and institutions',
                value: 'museums and institutions',
            },
            {
                label: 'Music',
                value: 'music',
            },
            {
                label: 'Nanotechnology',
                value: 'nanotechnology',
            },
            {
                label: 'Newspapers',
                value: 'newspapers',
            },
            {
                label: 'Non-profit organization management',
                value: 'non-profit organization management',
            },
            {
                label: 'Oil & energy',
                value: 'oil & energy',
            },
            {
                label: 'Online media',
                value: 'online media',
            },
            {
                label: 'Outsourcing/offshoring',
                value: 'outsourcing/offshoring',
            },
            {
                label: 'Package/freight delivery',
                value: 'package/freight delivery',
            },
            {
                label: 'Packaging and containers',
                value: 'packaging and containers',
            },
            {
                label: 'Paper & forest products',
                value: 'paper & forest products',
            },
            {
                label: 'Performing arts',
                value: 'performing arts',
            },
            {
                label: 'Pharmaceuticals',
                value: 'pharmaceuticals',
            },
            {
                label: 'Philanthropy',
                value: 'philanthropy',
            },
            {
                label: 'Photography',
                value: 'photography',
            },
            {
                label: 'Plastics',
                value: 'plastics',
            },
            {
                label: 'Political organization',
                value: 'political organization',
            },
            {
                label: 'Primary/secondary education',
                value: 'primary/secondary education',
            },
            {
                label: 'Printing',
                value: 'printing',
            },
            {
                label: 'Professional training & coaching',
                value: 'professional training & coaching',
            },
            {
                label: 'Program development',
                value: 'program development',
            },
            {
                label: 'Public policy',
                value: 'public policy',
            },
            {
                label: 'Public relations and communications',
                value: 'public relations and communications',
            },
            {
                label: 'Public safety',
                value: 'public safety',
            },
            {
                label: 'Publishing',
                value: 'publishing',
            },
            {
                label: 'Railroad manufacture',
                value: 'railroad manufacture',
            },
            {
                label: 'Ranching',
                value: 'ranching',
            },
            {
                label: 'Real estate',
                value: 'real estate',
            },
            {
                label: 'Recreational facilities and services',
                value: 'recreational facilities and services',
            },
            {
                label: 'Religious institutions',
                value: 'religious institutions',
            },
            {
                label: 'Renewables & environment',
                value: 'renewables & environment',
            },
            {
                label: 'Research',
                value: 'research',
            },
            {
                label: 'Restaurants',
                value: 'restaurants',
            },
            {
                label: 'Retail',
                value: 'retail',
            },
            {
                label: 'Security and investigations',
                value: 'security and investigations',
            },
            {
                label: 'Semiconductors',
                value: 'semiconductors',
            },
            {
                label: 'Shipbuilding',
                value: 'shipbuilding',
            },
            {
                label: 'Sporting goods',
                value: 'sporting goods',
            },
            {
                label: 'Sports',
                value: 'sports',
            },
            {
                label: 'Staffing and recruiting',
                value: 'staffing and recruiting',
            },
            {
                label: 'Supermarkets',
                value: 'supermarkets',
            },
            {
                label: 'Telecommunications',
                value: 'telecommunications',
            },
            {
                label: 'Textiles',
                value: 'textiles',
            },
            {
                label: 'Think tanks',
                value: 'think tanks',
            },
            {
                label: 'Tobacco',
                value: 'tobacco',
            },
            {
                label: 'Translation and localization',
                value: 'translation and localization',
            },
            {
                label: 'Transportation/trucking/railroad',
                value: 'transportation/trucking/railroad',
            },
            {
                label: 'Utilities',
                value: 'utilities',
            },
            {
                label: 'Venture capital & private equity',
                value: 'venture capital & private equity',
            },
            {
                label: 'Veterinary',
                value: 'veterinary',
            },
            {
                label: 'Warehousing',
                value: 'warehousing',
            },
            {
                label: 'Wholesale',
                value: 'wholesale',
            },
            {
                label: 'Wine and spirits',
                value: 'wine and spirits',
            },
            {
                label: 'Wireless',
                value: 'wireless',
            },
            {
                label: 'Writing and editing',
                value: 'writing and editing',
            },
        ],
        inputPlaceholder: 'Accounting, Government, Management etc.',
    },
    {
        label: _mft('leadHunterCampaign:audience.fields.companySize.label'),
        field: 'company_size',
        type: 'options',
        options: [
            {
                label: '1-10',
                value: '1-10'
            },
            {
                label: '11-50',
                value: '11-50'
            },
            {
                label: '51-200',
                value: '51-200'
            },
            {
                label: '201-500',
                value: '201-500'
            },
            {
                label: '501-1000',
                value: '501-1000'
            },
            {
                label: '1001-5000',
                value: '1001-5000'
            },
            {
                label: '5001-10000',
                value: '5001-10000'
            },
            {
                label: '10001+',
                value: '10001+'
            },
        ],
        inputPlaceholder: '',
    },
    {
        label: _mft('leadHunterCampaign:audience.fields.location.label'),
        field: 'location',
        type: 'search',
        searchUrl: route('api.lead-hunter.locations'),
        inputPlaceholder: 'Texas, United States'
    }
])

const parameters = reactive({})
const initialSearchPerformed = ref(false)
const waiting = ref(false)
const leadCount = ref(0)
const leadCountDisplay = ref(0)

const nextStage = () => {
    if (! searchIsValid && ! waiting.value) {
        return
    }
    emit('submitSearch', parameters)
}

const searchIsValid = computed(() => {
    return waiting.value || !initialSearchPerformed.value || leadCount.value === 0
})

const updateParameters = (_parameters) => {
    parameters.job_title = _parameters.job_title
    parameters.company_industry = _parameters.company_industry
    parameters.company_size = _parameters.company_size
    parameters.location = _parameters.location
}

onMounted(() => {
    searchFields.value.forEach((field) => {
        if(field.type === 'text') {
            parameters[field.field] = ''
        }

        if(field.type === 'multiText') {
            parameters[field.field] = []
        }

        if(field.type === 'options') {
            parameters[field.field] = []
        }

        if(field.type === 'search') {
            parameters[field.field] = []
        }
    })
})

watch(parameters, () => {
    emit('parametersUpdated', parameters)
}, {deep: true})

</script>

<template>
    <div>
        <h1 class="mt-2 mb-0">{{ _mft('leadHunterCampaign:createNew') }}</h1>
        <p class="mb-8 text-lg text-gray-500">{{ _mft('leadHunterCampaign:audience.title') }}</p>

        <div class="grid-cols-5 gap-8 md:grid">
            <div class="col-span-3">
                <lead-hunter-query
                    @initial-search-performed="initialSearchPerformed = true"
                    @waiting="waiting = $event"
                    @lead-count="leadCount = $event"
                    @lead-count-display="leadCountDisplay = $event"
                    @parameters-updated="updateParameters"
                ></lead-hunter-query>
            </div>
            <div class="col-span-2">
                <card-basic
                    overflow="visible"
                >
                <h5>What's the best search?</h5>
                <p>A broad search gives you more results, but less pin-pointed data.</p>

                <p>Some fields, such as number of employees are harder for us to get an accurate number from, and therefor can limit the results quickly.</p>
                </card-basic>
            </div>
        </div>

        <div
            v-if="initialSearchPerformed"
            class="lg:text-md"
        >
            <div
                class="fixed p-4 text-center transition-all transform -translate-x-1/2 bg-white shadow-xl left-1/2 z-modal rounded-wl lg:static lg:transform-none lg:bg-transparent lg:p-0 lg:shadow-none"
                :class="leadCount === 0 || waiting ? 'translate-y-full bottom-0' : 'translate-y-0 bottom-4'"
            >
                <p
                    v-if="! waiting"
                    class="mb-0 whitespace-nowrap"
                >
                    {{ _mft('leadHunterCampaign:audience.potentialLeadCount', {count: leadCountDisplay}) }}
                </p>
                <mf-spinner-medium
                    v-else
                    class="w-12 h-6 mb-0"
                />
            </div>
        </div>
        <p
            v-else
            class="text-center"
        >
            {{ _mft('leadHunterCampaign:audience.enterSearchTerms') }}
        </p>
        <div class="flex items-center justify-center mt-4 space-x-4">
            <slot name="actions"></slot>
            <button-success
                :disabled="searchIsValid"
                @click="nextStage"
            >{{ _mft('shared:action.continue') }}</button-success>
        </div>
    </div>
</template>

<style scoped>

</style>
